export default __webpack_public_path__ + "fc93d66bee92da4aedf64e50402708cc.svg";